import '../styles/About.css';
import profile_img from '../assets/profile.webp';
import github_logo from '../assets/github.svg'
import linkedin_logo from '../assets/linkedin.svg'
import mail_logo from '../assets/mail.svg'
import test from '../assets/test.svg';
import AboutSkills from './AboutSkills';

export default function About() {
    return (
        <div className='about' id='about'>
            <div className='about__container'>
                <div className='about__details'>
                    <div className='about__img'>
                        <img src={profile_img} alt='profile' loading="lazy"/>
                    </div>
                    <div className='about__contact'>
                        <div className='about__contact_logos'>
                            <a href='https://linkedin.com/in/alexuscr27' target="_blank" rel="noopener noreferrer">
                                <img src={linkedin_logo} alt='github logo'/>  
                            </a>
                            <a href='https://github.com/ALEXUSCR-27' target="_blank" rel="noopener noreferrer">
                                <img src={github_logo} alt='github logo'/>
                            </a>

                            <a href='mailto:asmalexander@hotmail.com'>
                                <img src={mail_logo} alt='github logo'/>
                            </a>
                        </div>
                        {/* <div className='about__cv'>
                            <a href='https://drive.google.com/uc?export=download&id=1SQ-28_PjY9KasI6RctTHyYXFJjIgPrnL'>Download CV</a>
                        </div> */}
                    </div>
                </div>
                <div className='about__text'>
                    <h1>Hi, I'm Alexander,</h1>
                    <img src={test} alt='profession' className='about__profession' />
                    <p>
                        Computing & Software Engineer specialized in research and development of 
                        scalable, high-quality software solutions, experienced in leveraging Linux 
                        and Windows environments to design, implement, and optimize applications that 
                        meet complex technical requirements. Skilled in collaborating with global, 
                        cross-functional teams, utilizing cutting-edge technologies to drive innovation, 
                        enhance system capabilities, and deliver impactful results.
                    </p>
                    <br/>
                    
                </div>
                
            </div>
            <div className='about__skills'>
                <AboutSkills />
            </div>
        </div>
    );
}